import React from 'react';
import PatientIntakesList from '../../PatientIntakesList';

// Patient intakes — generic list of patient-submitted forms (onboarding today;
// future re-assessments / follow-ups land here too). Shown to all staff roles.
export default function IntakesTab({ intakes, intakesTotalCount, withingsUserId }) {
  return (
    <PatientIntakesList
      intakes={intakes}
      totalCount={intakesTotalCount}
      withingsUserId={withingsUserId}
    />
  );
}
